const checksumMultipliers = [3, 7, 1];
export default function validRoutingNumber(routingNumber) {
  if (!/^\d{9}$/.test(routingNumber)) {
    return false;
  }
  const checksum = [...routingNumber].reduce((acc, num, idx) => {
    return acc + Number.parseInt(num, 10) * checksumMultipliers[idx % 3];
  }, 0);
  return checksum !== 0 && checksum % 10 === 0;
}